import { getStatusTile, getUserLevel } from './localstorage'

export const userLevel = {
  LEVEL1: 'level1',
  LEVEL2: 'level2',
}

export const haveUserLevel1 = () => {
  return getUserLevel() === userLevel.LEVEL1
}

export const isUserLevelOne = () => {
  if (haveUserLevel1()) {
    return true
  }
  return false
}
// check status 1.5
export const statusTileForUserLevelOne = () => {
  if (!getStatusTile()) {
    return false
  }
  if (!Array.isArray(getStatusTile())) {
    return false
  }
  return JSON.parse(getStatusTile())?.some(function (part) {
    return window.location.href.includes(part)
  })
}

export const isUserNeedUpgrade = () => {
  return statusTileForUserLevelOne()
}
